<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Informations patient</div>
        <div class="modal-body">
            <ng-container *ngIf="patientVcArrTmpl">
                <ng-container *ngFor="let patient of patientVcArrTmpl">
                    <div class="main" (click)="onSubmit(patient)">
                        <div class="infos">
                            <p class="nom-prenom">{{ patient.prenom }} {{ patient.nom }}</p>
                            <p class="ddn">{{ patient.dateNaissance }}</p>
                        </div>
                        <div class="select-button-wrapper">
                            <div class="icon"></div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <div class="button-wrapper">
                <div class="buttons">
                    <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>